import { ComponentProps } from 'react';
import { ClusteredPOIResult } from '@alltrails/search/types/algoliaResultTypes';
import { DropdownMenuItems } from '@alltrails/denali/components/DropdownMenu';
import PaddingAwarePopup from '../../PaddingAwarePopup';
import { getPOIPopupOffset } from '../POIResults/getPOIPopupOffset';
import styles from './ActivePOIPopupOptions.module.scss';

type ActivePOIPopupOptionsProps = {
  options: ComponentProps<typeof DropdownMenuItems>['options'];
  poi: ClusteredPOIResult;
};

const ActivePOIPopupOptions = ({ options, poi }: ActivePOIPopupOptionsProps) => {
  const { _geoloc, clusterCoordinates, photos_count } = poi;

  return (
    <PaddingAwarePopup
      closeButton={false}
      closeOnClick={false}
      focusAfterOpen={false}
      latitude={clusterCoordinates?.lat ?? _geoloc!.lat}
      longitude={clusterCoordinates?.lng ?? _geoloc!.lng}
      maxWidth="327"
      offset={getPOIPopupOffset(!!photos_count)}
      preferTopAnchor
    >
      <div className={styles.container}>
        <DropdownMenuItems options={options} />
      </div>
    </PaddingAwarePopup>
  );
};

export default ActivePOIPopupOptions;
